import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { SearchField } from "../SearchField/SearchField";
import { SelectedOption } from "./SelectedOption/SelectedOption";
import { withTranslations } from "../../../utils/withTranslations";
import "./SearchBar.scss";

import defaultLocales from "./locales";

export class USearchBar extends React.Component {
  static propTypes = {
    /** Locales object for rendering text */
    locales: PropTypes.object,
    /** Callback for when option is clicked */
    onOptionClick: PropTypes.func,
    /** Callback function to search */
    onSearch: PropTypes.func,
    /** Callback for when selected option is clicked */
    onSelectedOptionClick: PropTypes.func,
    /** Options to search through */
    options: PropTypes.arrayOf(PropTypes.object),
    /** Option that is currently selected */
    selectedOption: PropTypes.object,
    /** Customize option render */
    renderOption: PropTypes.func,
  };

  render() {
    const {
      locales,
      onOptionClick,
      onSearch,
      onSelectedOptionClick,
      options,
      renderOption,
      selectedOption,
    } = this.props;
    const className = classNames("SearchBar", { selected: !!selectedOption });
    return (
      <div className={className} data-testid="SearchBar">
        {selectedOption ? (
          <SelectedOption
            selectedOption={selectedOption}
            onSelectedClick={onSelectedOptionClick}
          />
        ) : (
          <div
            className="SearchBar__SearchField"
            data-testid="SearchBar__SearchField"
          >
            <SearchField
              options={options}
              onSearch={onSearch}
              onOptionClick={onOptionClick}
              placeholder={locales.search}
              renderOption={renderOption}
            />
          </div>
        )}
      </div>
    );
  }
}

const translatedSearchBar = withTranslations(defaultLocales)(USearchBar);

export { translatedSearchBar as SearchBar };

export default translatedSearchBar;
